import * as React from "react";
import { IInitialState } from "../../hooks/types";

/**
 * To maintain global state context
 */
export const StateContext = React.createContext<any>({});

export const reducer = (state: any, action: any) => {
    if (action.type === "set") {
        return {
            ...state,
            ...action.state
        }
    }
    return state;
};

export const StateProvider = ({ reducer, initialState, children }: {
    reducer: any; initialState: Partial<IInitialState>; children: any
}) => (
    <StateContext.Provider value={React.useReducer(reducer, initialState)}>
        {children}
    </StateContext.Provider>
);
